import React from "react";
import { banks } from "../mock";

import { tr } from "../i18n";
const BankChip = ({ name }) => (
  <div className="mx-3 shrink-0 flex items-center justify-center h-16 px-8 rounded-lg bg-white ring-1 ring-[#0b1f3a]/5 shadow-sm">
    <span className="font-display text-[18px] md:text-[20px] text-[#0b1f3a]/75 whitespace-nowrap">
      {name}
    </span>
  </div>
);

export default function BankMarquee() {
  const loop = [...banks, ...banks];
  return (
    <section className="bg-[#f6f2e9] py-10 border-y border-[#c2a15a]/15">
      <p className="text-center text-[12px] tracking-[0.3em] uppercase text-[#0b1f3a]/50 mb-6">
        {tr("Access a panel of 55+ banks & building societies")}
      </p>
      <div className="rh-marquee overflow-hidden relative">
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#f6f2e9] to-transparent z-10" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#f6f2e9] to-transparent z-10" />
        <div className="rh-marquee-track">
          {loop.map((b, i) => (
            <BankChip key={i} name={b} />
          ))}
        </div>
      </div>
    </section>
  );
}
